/* tslint:disable */
/* eslint-disable */
export enum FejlDashboardKanRetteFejlEnum {
  Nej = 'Nej',
  En = 'En',
  Flere = 'Flere'
}
